import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getTags({ commit }, filters) {
    commit('toggleLoading', true);
    return GraphQlClient.query(`
    query (
      $logistic_provider: Int!
      $delivery_methods: [Int]!,
      $document_type: String!
    ) {
      tags(
        logistic_provider: $logistic_provider,
        delivery_methods: $delivery_methods,
        document_type: $document_type
      ) {
        id
        tms_name
        logistic_provider_name
        taxes_type
        tag_name
        tag_value
      }
    }
    `, filters)
    .then(({ data }) => {
      const { tags } = data || {};
      commit('setTags', tags);
      commit('toggleLoading', false);
      return tags;
    })
    .catch(() => commit('toggleLoading', false));
  },

  getFilesImport({ commit }) {
    commit('toggleLoading', true);
    return GraphQlClient.query(`
    query {
      filesImport {
        items {
          file_name
          process_date
          process_status
          download_url
          upload_date
        }
        total
      }
    }`)
    .then(({ data }) => {
      const {
        items = [],
        total = 0,
      } = data.filesImport || {};
      commit('setFilesImport', items);
      commit('setTotalFiles', total);
      commit('toggleLoading', false);
    })
    .catch(() => commit('toggleLoading', false));
  },

  exportToExcel({ commit, state }, filters) {
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query (
        $logistic_provider: Int!
        $delivery_methods: [Int]!,
        $document_type: String!
      ) {
        exportTags(
          logistic_provider: $logistic_provider,
          delivery_methods: $delivery_methods,
          document_type: $document_type
        ) {
          ok
        }
      }`, filters)
      .then(() => commit('toggleLoading', false))
      .catch(() => commit('toggleLoading', false));
  },

  createNewTag({ commit }, filters) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $tms_name: String!,
      $logistic_provider_name: String!,
      $taxes_type: String!,
      $tag_name: String!,
      $tag_value: String!
    ) {
      updateTag(
        tms_name: $tms_name,
        logistic_provider_name: $logistic_provider_name,
        taxes_type: $taxes_type,
        tag_name: $tag_name,
        tag_value: $tag_value
      ) {
        ok
      }
    }`, filters)
    .then(() => commit('toggleLoading', false))
    .catch(() => commit('toggleLoading', false));
  },

  deleteTag({ commit }, id) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation ($id: String!) {
      deleteTag(id: $id) {
        ok
      }
    }`, { id })
    .then(() => commit('toggleLoading', false))
    .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/store/actions.js